import appApi from "@/services/api";
const useArrendamientoTipo = () => {
  const get = async () => {
    const response = await appApi().get("arrendamientos");
    return response.data;
  };
  return {
    get,
  };
};

export default useArrendamientoTipo;
